// Functions
export const getRefinedData = (data: CogsSummaryTypes) => {
  return {
    totalCogs: data.total_cogs,
    targetCogs: data.target_cogs,
    totalFoodCogs: data.total_food_cogs,
    totalAlcoholCogs: data.total_alc_cogs,
    lastUpdated: data.last_updated,
  };
};

const CogsValues = {
  act: null,
  pct: null,
};

// Constants
export const defaultCogs = {
  lastUpdated: "",
  totalCogs: CogsValues,
  targetCogs: CogsValues,
  totalFoodCogs: CogsValues,
  totalAlcoholCogs: CogsValues,
};
